<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp47',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-48">
    <module-title :title="moduleOption.title" margin-bottom="55" />
    <div class="comp-transverse-2 modules-id-48-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-id-48-item-${i}`"
        class="item"
        @click="onModuleItem(v)"
      >
        <div class="item-order">{{ i + 1 }}</div>
        <p class="item-headline h-line-1">{{ v.headline }}</p>
        <p class="line"></p>
        <p class="item-memo h-line-3">{{ filtersRichtext(v.memo) }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-48-content {
  display: flex;
  column-gap: 20px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 160px;
    height: 204px;
    background: url('~imgs/modules/comp48-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding: 0 20px;
    box-sizing: border-box;
    box-shadow: 0 4px 15px 0 rgba(44,153,178,0.1);
    position: relative;
    .item-order {
      position: absolute;
      left: 55px;
      top: -25px;
      width: 50px;
      height: 50px;
      background: #2C99B2;
      border-radius: 50%;
      font-size: 25px;
      font-family: siyuansong;
      font-weight: 800;
      color: #FDF7E5;
      line-height: 50px;
      text-align: center;
    }
    .item-headline {
      font-size: 17px;
      font-weight: bold;
      color: #000;
      margin-top: 40px;
    }
    .line {
      width: 32px;
      height: 3px;
      background-color: #2C99B2;
      margin-top: 20px;
    }
    .item-memo {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      line-height: 18px;
      margin-top: 20px;
    }
  }
  .item:nth-child(odd) {
    margin-top: 40px;
  }
}
</style>
